<template>
  <div :style="getStyle(data?.style)" @mouseleave="isContainerActive = false">
      <div
        @mousemove="checkProximity($event, childId), currentDivHover = childId"
        @mouseleave="resetProximity"
        v-for="childId in data?.props?.childrenIds"
        :key="childId"
        class="component"
      >
        <component
          :is="getComponentType(emailData[childId]?.type)"
          :data="emailData[childId]?.data"
          :dynamicIndex ="dynamicIndex"
          :emailData="emailData"
          :blockId="childId"
          @click.stop="shareProps(childId, emailData[childId]); isContainerActive = true, currentDiv = childId"
        ></component>
        <div v-if="isContainerActive  && currentDiv == childId" class="delete-button" @click.stop="deleteBlock(childId)">
          <span class="material-symbols-outlined">delete</span>
        </div>
        <div
          v-if="isNearTopButton && currentDivHover == childId"
          class="container-addButton top"
          @click.stop.self="toggleAddList($event, 'top', childId)"
        >+</div>
        <div
          v-if="isNearBottomButton  && currentDivHover == childId"
          class="container-addButton bottom"
          @click.stop.self="toggleAddList($event, 'bottom', childId)"
        >+</div>
      </div>
      <AddList
        v-if="showAddList && activeButtonId === activeButtonId"
        :style="addListStyle"
        :clicked = clicked
        :parentType = "'Container'"
        :parentId="activeChildComponent"
        :blockId="blockId"
        @close="closeAddList"
        @add-blockCo="addBlockContainer"
        ref="addList"
      />
    <EmptyBlock
      v-if="currentView === 'Edit' && !hasChildren"
      :parentId="blockId"
      :parentType="'Container'"
      @showAddList="showAddList($event, 'container', data)"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import EmptyBlock from './EmptyBlock.vue';
import HtmlBlock from './HtmlBlock.vue';
import HeadingBlock from './HeadingBlock.vue';
import TextBlock from './TextBlock.vue';
import SpacerBlock from './SpacerBlock.vue';
import ImageBlock from './ImageBlock.vue';
import ButtonBlock from './ButtonBlock.vue';
import DividerBlock from './DividerBlock.vue';
import ColumnsContainerBlock from './ColumnsContainerBlock.vue';
import ContainerBlock from './ContainerBlock.vue';
import RulesetBlock from './RulesetBlock.vue';
import QrBlock from './QrBlock.vue';
import AddList from '../Reusables/AddList.vue';

export default {
  name: 'ContainerBlock',
  components: {
    EmptyBlock,
    AddList,
  },
  props: {
    data: Object,
    emailData: Object,
    blockId: String, //ID of the rendered container, props form Preview.vue
    dynamicIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      showAddButton: false,
      showAddList: false,
      addListStyle: {},
      activeChildComponent: null, //stores Id of Child Component, where the AddList was triggered from
      isContainerActive: false,
      isNearTopButton: false,
      isNearBottomButton: false,
      clicked: 'container', //type of the clicked component
      position: 'bottom',
      currentDiv: '', //stores the clicked div ID
      currentDivHover: '', //stores the currently hovered div
      addPadding: null
    };
  },
  computed: {
    ...mapGetters(['getView']),
    ...mapState(['containerEditMode']) ,
    currentView() {
      return this.getView;
    },
    hasChildren() {
      return this.data?.props?.childrenIds?.length > 0;
    },
  },
  methods: {
    ...mapActions(['updateSharedData', 'removeBlock', 'addNewBlock']),
    getStyle(style) {
      let border;
      const backgroundColor = style?.backgroundColor || null;
      if (style?.borderColor && style?.borderColor != null) {
        border = `${style?.borderColor} ${style?.borderWidth || 1 }px solid` || null;
      }
      const borderRadius = `${style?.borderRadius}px` || null;
      let width;
      if (style?.width == 'inherit') {
        width = 'inherit';
      } else {
        width = `${style?.width}px` || 'inherit';
      }
      let height;
      if (style?.height == 'auto') {
        height = 'auto';
      } else {
        height = `${style?.height}px` || 'auto';
      }
      const padding = style?.padding
        ? `${style.padding.top + this.addPadding}px ${style.padding.right}px ${style.padding.bottom + this.addPadding}px ${style.padding.left}px`
        : '0';
      /* const margin = style?.margin 
        ? `0px ${style.margin.right}px 0px ${style.margin.right}px`
        : '0 auto' */ 
      if(style?.position) {
        const position = style.position 
        const left = `${style.direction.left}px`;
        const top = `${style.direction.top}px`;
        return {
          backgroundColor: backgroundColor,
          border: border,
          borderRadius: borderRadius,
          padding: padding,
          width: width,
          height: height,
          position: position,
          left: left,
          top: top,
       /*  margin: margin */
      }} else {
        return {
          backgroundColor: backgroundColor,
          border: border,
          borderRadius: borderRadius,
          padding: padding,
          width: width,
          height: height
       /*  margin: margin */
      }};
    },
    getComponentType(type) {
      const components = {
        Heading: HeadingBlock,
        HtmlBlock: HtmlBlock,
        Text: TextBlock,
        Spacer: SpacerBlock,
        Image: ImageBlock,
        Container: ContainerBlock,
        Button: ButtonBlock,
        Divider: DividerBlock,
        ColumnsContainer: ColumnsContainerBlock,
        Qr: QrBlock,
        Ruleset: RulesetBlock,
      };
      return components[type] || 'div';
    },
    shareProps(childId, data) {
      this.updateSharedData({id: childId, data});
    },
    toggleAddList(event, position, childId) {
      event.stopPropagation();
      this.activeChildComponent = childId;
      this.position = position;
      this.activeButtonId = childId; // Set the active button ID
      const buttonRect = event.target.getBoundingClientRect();
      const parentRect = event.target.parentElement.getBoundingClientRect();
      const top = position === 'top' ? buttonRect.top - parentRect.top : buttonRect.bottom - parentRect.top;
      const left = buttonRect.left - parentRect.left;

      this.addListStyle = {
        top: `${top}px`,
        left: `${left}px`,
        transform: 'translateY(20px)', // adjust as needed
        position: 'absolute',
        zIndex: 10,
      };
      this.showAddList = true;
      document.addEventListener('click', this.handleClickOutside);
    },
    handleClickOutside(event) {
      const addListElement = this.$refs.addList?.$el;
      if (this.showAddList && addListElement && !addListElement.contains(event.target)) {
        this.closeAddList();
      }
    },
    closeAddList() {
      this.showAddList = false;
      this.activeButtonId = null;
      document.removeEventListener('click', this.handleClickOutside);
    },
    addBlockContainer(type) {
      console.log('test', this.blockId)
      this.addNewBlock({
        type: type,
        targetId: this.activeChildComponent,
        position: this.position,
        parentId: this.blockId,
        parentType: 'Container'
      });
      this.showAddList = false;
    },
    deleteBlock(childId) {
      this.removeBlock({ parentId: this.blockId, parentType: 'Container', blockId: childId });
    },
    checkProximity(event, childId) {
      const rect = event.currentTarget.getBoundingClientRect();
      const mouseY = event.clientY;
      const mouseX = event.clientX;
      // Check if the mouse is over any clickable elements within the container
      const elementUnderMouse = document.elementFromPoint(mouseX, mouseY);
      const isInteractiveElement = elementUnderMouse && ['A', 'BUTTON', 'INPUT', 'TEXTAREA', 'SELECT', 'OPTION'].includes(elementUnderMouse.tagName);

      if (!isInteractiveElement) {
        this.isNearTopButton = mouseY >= rect.top - 10 && mouseY <= rect.top + 10 && mouseX >= rect.left && mouseX <= rect.right;
        this.isNearBottomButton = mouseY >= rect.bottom - 10 && mouseY <= rect.bottom + 10 && mouseX >= rect.left && mouseX <= rect.right;
      } else {
        this.isNearTopButton = false;
        this.isNearBottomButton = false;
      }
    },
    resetProximity() {
      this.isNearTopButton = false;
      this.isNearBottomButton = false;
    }
  },
  watch: { //state to increase padding of containers for easier editing
    containerEditMode(newVal) {
      console.log(newVal)
      this.addPadding = newVal ? 20 : 0;
    }
  },
  mounted() {
    this.addPadding = this.containerEditMode ? 20 : 0;
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style scoped>
.component {
  position: relative;
}
.component:hover {
  box-shadow: 0 0 0 2px var(--primary-color);
  z-index: 10;
  /* border: 1px solid var(--primary-color); */
}

.container-addButton {
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: var(--primary-color);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.clickedAddButton {
  background: var(--secondary-color);
}

.container-addButton.top {
  top: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.container-addButton.bottom {
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
}

.add-list {
  position: absolute;
  z-index: 10;
}

.delete-button {
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
  padding: 5px;
  position: absolute;
  top: -10px;
  left: -10px;
  background: white;
  width: 20px;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.component-container:hover .delete-button {
  opacity: 1;
}
</style>
